import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { LoaderInterceptor } from './loader.interceptor.service';
import { getHttpEventReducer } from './store/loader.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('loading-state', getHttpEventReducer),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
  ],
})
export class NgrxLoaderModule {}
